import { render, staticRenderFns } from "./TeacherColorRace.vue?vue&type=template&id=0f5d0f43"
import script from "./TeacherColorRace.vue?vue&type=script&lang=js"
export * from "./TeacherColorRace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5d0f43')) {
      api.createRecord('0f5d0f43', component.options)
    } else {
      api.reload('0f5d0f43', component.options)
    }
    module.hot.accept("./TeacherColorRace.vue?vue&type=template&id=0f5d0f43", function () {
      api.rerender('0f5d0f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherColorRace.vue"
export default component.exports